import { withStyles } from "@mui/styles"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import { Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Pagination, TextField, Typography } from "@mui/material";
import LlmDocumentKnowledgeBasesList from "./llmdocumentknwoledgebaseslist";
import AvailableKnowledgeBases from "./availableknowledgebases";
import { useState } from "react";
import Api from "src/services/api";
import { PapiroConsole } from "src/utils/papiroConsole";
import { Clear, Close, Search, ZoomIn } from "@mui/icons-material";
import SimpleSelect from 'src/components/select/simple-search';

const LlmArticles = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading, loading, hirerid } = props

    const [openKnowledgeBasesDialog, setOpenKnowledgeBasesDialog] = useState(false)
    const [knowledgeBases, setKnowledgeBases] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [pageStart, setPageStart] = useState(1)
    const [pageEnd, setPageEnd] = useState(10)
    const [selected, setSelected] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterSelected, setFilterSelected] = useState(0)
    const [contentFilter, setContentFilter] = useState([])

    const filters = [
        { name: intl.formatMessage({ id: "keywords" }), id: "keywords" },
        { name: intl.formatMessage({ id: "author" }), id: "createduser" },
        { name: intl.formatMessage({ id: "updated.user" }), id: 'updateduser' },
        { name: intl.formatMessage({ id: "menu.organizationpatrimonies" }), id: "patrimony" },
        { name: intl.formatMessage({ id: "description" }), id: "description" },
        { name: intl.formatMessage({ id: "title" }), id: "title" },
        { name: intl.formatMessage({ id: "id" }), id: "id" },
        { name: intl.formatMessage({ id: "For.internal.use.only" }), id: "onlyinternuse" }
    ]

    const setPaginationAvailable = (count, page) => {
        setTotalPages(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStart(start)
        setPageEnd(Math.min(start + 9, count))
    }

    const onChangePaginateAvailable = (event, value) => {
        setPage(value)
        getAvaliableKnowledgeBases(value)
    }

    const getAvaliableKnowledgeBases = async (page = 1) => {
        let url = `/knowledgebases/paginate?page=${page}`

        const newFilter = contentFilter.map(item => item.id).join("@")
        const newSearch = contentFilter.map(item => item.value).join("@")
        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`
        }
        url += `&llmdocument=false`
        onLoading(true)
        await Api.get(url)
            .then((response) => {
                if (response) {
                    setTotal(response.data?.count)
                    setPaginationAvailable(response.data?.count, page)
                    setKnowledgeBases(response.data.data)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const openKnowledgeBases = async () => {
        await getAvaliableKnowledgeBases()
        setOpenKnowledgeBasesDialog(true)
    }

    const onSelect = (id) => {
        if (selected.indexOf(id) > -1) {
            setSelected(selected.filter(i => i != id))
        } else {
            setSelected([...selected, id])
        }
    }

    const onSave = async () => {
        onLoading(true)
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('llmId', llm.id)
        data.append('urlapi', apiurl)
        const relationids = selected.join(",")

        data.append('relationids', relationids)

        await Api.post(`/llmdocumentknowledgebases`, data)
            .then(async (response) => {
                onShowNotification(intl.formatMessage({ id: "add.success" }), 'success')
                if (response)
                    await setRefresh(!refresh)
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.uploading.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        setSelected([])
        onLoading(false)
        setOpenKnowledgeBasesDialog(false)
    }

    const addFilter = async () => {
        PapiroConsole.log("addFilter")
        PapiroConsole.log(filterSelected)
        if (searchValue.trim() == '' && filterSelected == 0) {
            onShowNotification(intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" }), 'error')
        } else {
            if (searchValue != '' && filterSelected != 0) {

                if (filterSelected === "open") {
                    let date = searchValue.split("/");
                    if (date.length === 3) {
                        date = `${date[2]}-${date[1]}-${date[0]}`
                    }
                    let nameField
                    for (let i = 0; i < filters.length; i++) {

                        if (filters[i].id === filterSelected) {
                            nameField = filters[i].name
                        }
                    }

                    setContentFilter([...contentFilter, { id: filterSelected, name: nameField, value: searchValue }])

                } else {
                    let nameField
                    for (let i = 0; i < filters.length; i++) {
                        if (filters[i].id === filterSelected) {
                            nameField = filters[i].name
                        }
                    }

                    setContentFilter([...contentFilter, { id: filterSelected, name: nameField, value: searchValue }])
                }

                setSearchValue('')
                setFilterSelected(0)
            }
        }
    }

    const onFieldChange = (event) => {
        setSearchValue(event.target.value)
        setPage(1)
    }

    const searchItens = async () => {
        if (searchValue.trim() != '' && filterSelected != 0) {
            await addFilter()
        }
        if (contentFilter && contentFilter.length > 0) {
            onLoading(true)
            await getAvaliableKnowledgeBases(page)
        }
    }

    const clearFields = () => {
        setSearchValue('')
        setFilterSelected(0)
        setPage(1)
        setContentFilter([])
        getAvaliableKnowledgeBases(1);
    }

    const changeValues = (stateName, value) => {
        setFilterSelected(value)
    }

    const handleDelete = (chipToDelete) => {
        var newvalue = [];

        contentFilter.forEach((item, index) => {
            if (index !== chipToDelete && item.value.trim() !== "") {
                newvalue.push(item)
            }
        })

        // Atualiza o estado e o localStorage
        setContentFilter(newvalue)

        if (newvalue.length === 0) {
            clearFields()
        } else {
            getAvaliableKnowledgeBases()
        }
    }

    return (
        <Grid container gap={2} paddingTop={2}>
            <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={openKnowledgeBases} style={{ marginBottom: 12 }} minWidth={'25%'}>
                    {intl.formatMessage({ id: "add" })}
                </Button>
            </Grid>

            <LlmDocumentKnowledgeBasesList
                classes={classes}
                intl={intl}
                llm={llm}
                onShowNotification={onShowNotification}
                onLoading={onLoading}
                loading={loading}
                hirerid={hirerid}
                knowledgeBases={knowledgeBases}
                refresh={refresh}
            />

            <Dialog
                open={openKnowledgeBasesDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={_ => setOpenKnowledgeBasesDialog(false)}
                maxWidth="xl"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                        },
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title">{intl.formatMessage({ id: "knowledgebases" })}</DialogTitle>
                <IconButton
                    aria-label="fechar"
                    onClick={() => setOpenKnowledgeBasesDialog(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent >
                    <DialogContentText>
                        {contentFilter &&
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={12}>
                                    <Card className="background-title-search">
                                        <CardContent>
                                            <Grid container spacing={1} alignItems="flex-end">
                                                <Grid item xs={8} md={6}>
                                                    <Typography variant="h5">
                                                        {intl.formatMessage({ id: "filters" })}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <strong>
                                                        {contentFilter.map((i, key) => {
                                                            if (i.value.trim() != "") {
                                                                return <Chip
                                                                    key={key}
                                                                    label={i.name + ": " + i.value}
                                                                    onDelete={() => handleDelete(key)}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                />
                                                            }

                                                        })}
                                                    </strong>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        }

                        <Grid container spacing={6}>
                            <Grid item xs={12} sm={12}>
                                <Card className="background-title-search">
                                    <CardContent>
                                        <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
                                            <Grid item xs={6} sm={6} md={6} lg={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <SimpleSelect
                                                    label={intl.formatMessage({ id: "field" })}
                                                    options={filters}
                                                    stateName='filter'
                                                    changeSelect={changeValues}
                                                    selected={filterSelected} />
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={6} lg={3}>
                                                <TextField type="text"
                                                    name="searchValue"
                                                    value={searchValue}
                                                    placeholder={intl.formatMessage({ id: "search" })}
                                                    onChange={onFieldChange} />
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={2} lg={1}>
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    size='large'
                                                    onClick={addFilter}
                                                    className={classes.button}
                                                    style={{ marginRight: 4, marginLeft: 8 }} >
                                                    <ZoomIn />
                                                </Button>
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={2} lg={1}>
                                                <Button
                                                    variant='contained'
                                                    color='secondary'
                                                    size='large'
                                                    className={classes.button}
                                                    style={{ marginRight: 4 }}
                                                    onClick={_ => getAvaliableKnowledgeBases()} >
                                                    <Search />
                                                </Button>
                                            </Grid>
                                            <Grid item xs={6} sm={6} md={2} lg={1}>
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    size='large'
                                                    onClick={clearFields}
                                                    className={classes.button} >
                                                    <Clear />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                    <AvailableKnowledgeBases
                        classes={classes}
                        intl={intl}
                        llm={llm}
                        onShowNotification={onShowNotification}
                        onLoading={onLoading}
                        loading={loading}
                        hirerid={hirerid}
                        knowledgeBases={knowledgeBases}
                        selected={selected}
                        setSelected={(id) => onSelect(id)}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                        <Grid item xs={12} md={3}>
                            <Pagination count={totalPages} page={page} onChange={onChangePaginateAvailable} />
                        </Grid>
                        <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                            {pageStart} {<FormattedMessage id="to" />} {pageEnd} {<FormattedMessage id="of" />} {total} {<FormattedMessage id="register" />}
                        </Grid>
                        <Grid item xs={12} md={4} />
                        <Grid item xs={12} md={1}>
                            <Button onClick={_ => setOpenKnowledgeBasesDialog(false)} color="secondary">
                                {intl.formatMessage({ id: "close" })}
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button onClick={onSave} color="primary" variant="contained">
                                {intl.formatMessage({ id: "save" })}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid >
    )
}

export default injectIntl(withStyles(Styles)(LlmArticles))